import Vue from "vue";
import App from "./App";
import store from "./store";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import Vue2Leaflet from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuetify);
Vue.use(VueAxios, axios);

// We SHOULD be able to set this via `process.env`, but I was not able to get
// this working. This way we could just define the URLs for local development
// and production and not change it all the time by hand..
Vue.axios.defaults.baseURL =
  "https://growingsolutions-backend.physikelearning.de";

Vue.component("v-map", Vue2Leaflet.Map);
Vue.component("v-tilelayer", Vue2Leaflet.TileLayer);
Vue.component("v-marker", Vue2Leaflet.Marker);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  render: h => h(App)
});
